import React, { useEffect } from 'react';
import { Button } from "react-bootstrap";
import { ArrowCircleRightIcon, ArrowCircleLeftIcon } from "@heroicons/react/outline";
import ReactPlayer from "react-player";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { PlayIcon } from "@heroicons/react/solid";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from 'lodash';

import { changeUserAttribute } from "../../actions/auth";
import './Checklist.scss';

const ReactSwal = withReactContent(Swal);

const adminFeatures = [
  {
    title: 'Sign up and create an account',
    video: null,
    route: null,
    checked: true
  },
  {
    title: 'add and/or import your content',
    video: 'https://www.youtube.com/watch?v=l0WRZMQJQjE',
    route: '/add-import',
    checked: false
  },
  {
    title: 'set up funnel stages, content types, products, and set a custom domain',
    video: 'https://www.youtube.com/watch?v=Z4BD20mSq2g',
    route: '/team-settings',
    checked: false
  },
  {
    title: 'configure branding color and logo',
    video: 'https://www.youtube.com/watch?v=GKn3zHrY0u0',
    route: '/team-settings/branding',
    checked: false
  },
  {
    title: 'add other users and build the team',
    video: 'https://www.youtube.com/watch?v=61XaQjUX_44',
    route: '/team-settings/manage-users',
    checked: false
  },
]

const userFeatures = [
  {
    title: 'activate your account',
    video: null,
    route: null,
    checked: true
  },
  {
    title: 'share content and track views',
    video: 'https://www.youtube.com/watch?v=KW3g8akIth0',
    route: '/dashboard',
    checked: false
  },
  {
    title: 'build collections and sites',
    video: 'https://www.youtube.com/watch?v=F7dJQY5CHbw',
    route: '/dashboard',
    checked: false
  },
  {
    title: 'add the browser extension',
    video: 'https://www.youtube.com/watch?v=gsoBo9NE-es',
    route: process.env.REACT_APP_EXTENSION_INSTALL_URL,
    checked: false
  }
]

const Checklist = props => {
  const goBack = () => {
    props.changeUserAttribute({ name: 'state', value: 'onboarding-01' });
    props.history.push('/onboarding/infographics');
  }

  const goNext = () => {
    props.changeUserAttribute({ name: 'state', value: 'new user' });
    props.history.push('/dashboard');
  }

  const onClickVideo = video => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <div>
          <ReactPlayer className="video-player" 
            url={video} 
            playing
            width="1024px"
            height="576px"
            controls
            loop
          />
        </div>
      )
    })
    .then(result => {
    });

  }

  const onClickRoute = route => {
    if (route) {
      props.changeUserAttribute({ name: 'state', value: 'new user' });
      if (route.includes("https://")) { //handle external links
        window.location.assign(route);
      } else {
        props.history.push(route); // route internally
      }
    }      
  }

  const completeSetup = _.get(props, 'history.location.pathname', '').includes('onbboarding-checklist');
  const isAdmin = _.get(props, "cognitoUser.attributes['custom:role']", '') === 'admin';
  const features = isAdmin ? adminFeatures : userFeatures;
  const title = isAdmin ? 'Best practices to get started:' : 'How to get started:';

  return (
    <div className="onboarding-checklist-container">
      <div className="arrow-box">
        {!completeSetup && <ArrowCircleLeftIcon onClick={goBack} />}
      </div>
      <div className="content-view">
        <h1>{title}</h1>
        <div className="features-container">
          {
            features.map((feat, idx) => (
              <div key={idx} className="feature-container left">
                <div className={`title${feat.checked ? ' checked' : ''}`}>{feat.title}</div>
                {(feat.video || feat.route) && (
                  <div className="actions">
                    <div className="action">
                      <div className="youtube-icon">
                        <div className="back-overlay" />
                        <PlayIcon onClick={() => onClickVideo(feat.video)} />
                      </div>
                      <a onClick={() => onClickVideo(feat.video)}>Watch how</a>
                    </div>
                    <div className="action">
                      <ArrowCircleRightIcon onClick={() => onClickRoute(feat.route)} />
                      <a onClick={() => onClickRoute(feat.route)}>Do it now</a>
                    </div>
                  </div>
                )}
              </div>
            ))
          }
        </div>
        <Button variant="outline-success" onClick={goNext}>Skip steps</Button>
      </div>
      <div className="arrow-box">
        {/* <ArrowCircleRightIcon onClick={goNext} /> */}
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  user: state.auth.tenant,
  cognitoUser: state.auth.cognitoUser
});

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    changeUserAttribute
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Checklist);
